import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css';
import { Lazyload,NavBar,Tab,Tabs,Grid,GridItem,Popup } from 'vant';
import Vuei18n from "vue-i18n";
import md5 from 'js-md5';

Vue.prototype.$md5 = md5;
Vue.use(Vuei18n);
Vue.use(Lazyload);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Popup);
const i18n = new Vuei18n({
    locale: 'en-US',
    messages: {
        'zh-CN': require('@/assets/lang/zh_CN.json'),
        'en-US': require('@/assets/lang/en_US.json'),
        'zh-TW': require('@/assets/lang/zh_HK.json'),
        'zh-HK': require('@/assets/lang/zh_HK.json'),
        'id-ID': require('@/assets/lang/id_ID.json'),
        //'th-TH': require('@/assets/lang/th_TH.json'),
        'ko-KR': require('@/assets/lang/ko_KR.json'),
        'ru-RU': require('@/assets/lang/ru_RU.json'),
    }
});
window.i18n = i18n
Vue.config.productionTip = false

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')